import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { mockData } from '../../mock';
import ResponsiveImage from '../ResponsiveImage';

const ProgramsSection = () => {
  const navigate = useNavigate();
  const { programs } = mockData;

  return (
    <section
      id="programs"
      className="section-padding"
      data-testid="programs-section"
    >
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="section-title">Our Programs</h2>
          <p className="section-subtitle">
            Evidence-based programs structured to deliver lasting capability, mobility and vitality.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {programs.map((program) => (
            <Card
              key={`program-${program.id}`}
              className="program-card group cursor-pointer"
              onClick={() => navigate(`/pricing/${program.id}`)}
              data-testid={`program-card-${program.id}`}
            >
              {program.image && (
                <div
                  className="blog-preview-image"
                  style={{ borderRadius: '12px 12px 0 0', overflow: 'hidden' }}
                >
                  <ResponsiveImage
                    src={program.image}
                    alt={program.name}
                    sizes="(max-width: 768px) 100vw, (max-width: 1280px) 50vw, 33vw"
                  />
                  <div className="blog-category-badge">{program.category}</div>
                </div>
              )}
              <CardHeader>
                <CardTitle className="program-name">{program.name}</CardTitle>
                <div className="program-meta">
                  <span className="program-duration">{program.duration}</span>
                </div>
                <CardDescription className="program-ideal">{program.ideal}</CardDescription>
              </CardHeader>
              <CardContent>
                <p
                  className="text-text-secondary mb-4 line-clamp-3"
                  data-testid={`program-features-${program.id}`}
                >
                  {program.features.slice(0, 3).join(' • ')}
                </p>
                <div
                  className="flex items-baseline gap-2 mb-4"
                  data-testid={`program-price-${program.id}`}
                >
                  <span
                    style={{
                      fontSize: '1.5rem',
                      fontWeight: 800,
                      color: 'var(--brand-accent, #FFD700)',
                    }}
                  >
                    {program.price}
                  </span>
                </div>
                <Button className="btn-primary w-full group-hover:scale-105 transition-transform">
                  View Details
                  <ArrowRight size={18} className="ml-2 inline" />
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProgramsSection;
